var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1182.5 3"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-edited_divisor"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1182.5,
    height: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edited_divisor",
    clipPath: "url(#clip-edited_divisor)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_FX_13b_Navigation_Bar",
    "data-name": "Icons_FX_13b_Navigation Bar",
    transform: "translate(-82.5 -72.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M82.5,74c378.8-2,803.7-2,1182.5,0C886.2,76,461.3,76,82.5,74Z",
    fill: "#303030"
  })))));
};
export default __webpack_public_path__ + "static/media/edited_divisor.4a050817.svg";
export { SvgComponent as ReactComponent };